import React from "react";

export const ConceptER: React.FC<{
  activeCard?: "pattern" | "material" | "synthesis" | null;
  onCardSelect?: (card: "pattern" | "material" | "synthesis") => void;
}> = ({ activeCard = null, onCardSelect }) => {
  const makeCardInteractivity = (
    card: "pattern" | "material" | "synthesis"
  ): React.HTMLAttributes<HTMLDivElement> => {
    if (!onCardSelect) return {};
    return {
      role: "button",
      tabIndex: 0,
      onClick: () => onCardSelect(card),
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onCardSelect(card);
        }
      },
    };
  };

  return (
    <div className="concept-er-horizontal">
      <div className="flow-container">
        
        {/* Step 1: Input */}
        <div className="flow-step" id="step-input">
          <div className="json-card">
            <div className="json-title">Input</div>
            <div className="json-content">
              {`{
  "RecordAudioFile": {
    "path": "string"
  },
  "PatternSourceAudio": {
    "path": "string"
  }
}`}
            </div>
          </div>
        </div>

        <div className="flow-connector-svg">
          <svg width="60" height="200" viewBox="0 0 60 200">
            <path 
              d="M0,50 C30,50 30,30 60,30" 
              fill="none" 
              stroke="#333" 
              strokeWidth="1.5"
              className="flow-path"
            />
            <path 
              d="M0,50 C30,50 30,130 60,130" 
              fill="none" 
              stroke="#333" 
              strokeWidth="1.5"
              className="flow-path"
            />
          </svg>
        </div>

        {/* Step 2: Analysis / Generation */}
        <div className="flow-step" id="step-analysis">
          <div className="flow-column">
            <div
              className={`json-card ${onCardSelect ? "is-tappable" : ""} ${activeCard === "pattern" ? "is-active" : ""}`}
              id="card-pattern"
              aria-label="Pattern"
              {...makeCardInteractivity("pattern")}
            >
              <div className="json-title">Pattern</div>
              <div className="json-content">
                {`{
  "VelocityPattern": {
    "bars": "int",
    "steps": "int",
    "tracks": "p00..p40"
  }
}`}
              </div>
            </div>
            <div
              className={`json-card ${onCardSelect ? "is-tappable" : ""} ${activeCard === "material" ? "is-active" : ""}`}
              id="card-material"
              aria-label="Material"
              {...makeCardInteractivity("material")}
            >
              <div className="json-title">Material</div>
              <div className="json-content">
                {`{
  "MaterialSet": {
    "path": "output/material/",
    "samples": "p00..p40.wav"
  }
}`}
              </div>
            </div>
          </div>
        </div>

        <div className="flow-connector-svg">
          <svg width="60" height="200" viewBox="0 0 60 200">
            <path 
              d="M0,30 C30,30 30,80 60,80" 
              fill="none" 
              stroke="#333" 
              strokeWidth="1.5"
              className="flow-path"
            />
            <path 
              d="M0,130 C30,130 30,80 60,80" 
              fill="none" 
              stroke="#333" 
              strokeWidth="1.5"
              className="flow-path"
            />
          </svg>
        </div>

        {/* Step 3: Synthesis */}
        <div className="flow-step" id="step-synthesis">
          <div
            className={`json-card highlight ${onCardSelect ? "is-tappable" : ""} ${activeCard === "synthesis" ? "is-active" : ""}`}
            id="card-synthesis"
            aria-label="Synthesis"
            {...makeCardInteractivity("synthesis")}
          >
            <div className="json-title">Synthesis</div>
            <div className="json-content">
              {`{
  "TrackWav": {
    "path": "output/track/*.wav",
    "bpm": "float",
    "pitch_system": "41-EDO"
  }
}`}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
